import { render } from "./MainNew.vue?vue&type=template&id=b972f76a&scoped=true"
const script = {}

import "./MainNew.vue?vue&type=style&index=0&id=b972f76a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b972f76a"]])

export default __exports__